import type { ObscurationBounds } from './types';

// Extends beyond the supported Spain/Balearics region so the raster edge stays
// outside the default map view. At 800 × 600, samples are roughly 3–5 km apart.
export const OBSCURATION_BOUNDS: ObscurationBounds = {
  west: -22,
  south: 28,
  east: 18,
  north: 58,
};

export const OBSCURATION_WIDTH = 800;
export const OBSCURATION_HEIGHT = 600;
export const OBSCURATION_STEP_MS = 10_000;
export const OBSCURATION_CACHE_SIZE = 8;
